// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"1adc2ecd","214":"b081a2eb","241":"1adc2ecd","561":"1adc2ecd","901":"b081a2eb"}[chunkId] + ".chunk.css";
};